var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 32,
    viewBox: "0 0 152 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.658 0c3.273 0 5.65 2.416 5.65 5.745v6.563h-2.29V5.745c0-1.884-1.507-3.417-3.36-3.417s-3.36 1.533-3.36 3.417v6.563h-2.29V5.745c0-1.884-1.507-3.417-3.36-3.417-1.851 0-3.358 1.533-3.358 3.417v6.563H0V5.745C0 2.416 2.376 0 5.649 0c1.725 0 3.596 1.074 4.504 2.573C11.057 1.075 12.927 0 14.658 0z",
    id: "3easxwhcia"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.154 0a6.161 6.161 0 0 1 6.154 6.154 6.16 6.16 0 0 1-6.154 6.154A6.16 6.16 0 0 1 0 6.154 6.161 6.161 0 0 1 6.154 0zm0 2.322a3.836 3.836 0 0 0-3.832 3.832 3.837 3.837 0 0 0 3.832 3.832 3.837 3.837 0 0 0 3.832-3.832 3.836 3.836 0 0 0-3.832-3.832z",
    id: "17wt3gtyfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.154 0a6.161 6.161 0 0 1 6.154 6.154 6.16 6.16 0 0 1-6.154 6.154A6.16 6.16 0 0 1 0 6.154 6.161 6.161 0 0 1 6.154 0zm0 2.322a3.836 3.836 0 0 0-3.832 3.832 3.836 3.836 0 0 0 3.832 3.832 3.836 3.836 0 0 0 3.832-3.832 3.836 3.836 0 0 0-3.832-3.832z",
    id: "42l08u0kse"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37 0v6.723c.826-.905 2.08-1.42 3.476-1.42 3.388 0 5.846 2.462 5.846 5.854v6.69h-2.37v-6.69c0-1.92-1.559-3.481-3.476-3.481a3.483 3.483 0 0 0-3.476 3.481v6.69H0V0h2.37z",
    id: "z5b5lfuxmg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.154 0c3.393 0 6.154 2.574 6.154 6.154v6H9.986v-1.517c-1.172 1.109-2.46 1.67-3.832 1.67A6.16 6.16 0 0 1 0 6.155 6.161 6.161 0 0 1 6.154 0zm0 2.322a3.836 3.836 0 0 0-3.832 3.832 3.836 3.836 0 0 0 3.832 3.832 3.836 3.836 0 0 0 3.832-3.832 3.836 3.836 0 0 0-3.832-3.832z",
    id: "usez8f0q8i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.538 0c.849 0 1.539.69 1.539 1.538a1.54 1.54 0 0 1-1.539 1.539A1.54 1.54 0 0 1 0 1.538C0 .69.69 0 1.538 0z",
    id: "0zepm04izk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.322 0v7.218c1.171-1.108 2.46-1.67 3.832-1.67 3.393 0 6.154 2.76 6.154 6.15 0 3.39-2.761 6.148-6.154 6.148S0 15.088 0 11.698V0h2.322zm3.832 7.87a3.834 3.834 0 0 0-3.832 3.828 3.835 3.835 0 0 0 3.832 3.828 3.835 3.835 0 0 0 3.832-3.828 3.834 3.834 0 0 0-3.832-3.829z",
    id: "6e3slel4wm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.007 0c.046 0 .09 0 .135.002 1.815.044 3.357.7 4.461 1.897 1.158 1.255 1.792 3.068 1.695 4.85l-.007.145c-.008.167-.016.34-.036.456l-.011.068H2.52c.544 1.517 2.016 2.568 3.62 2.568a3.825 3.825 0 0 0 2.868-1.299l.054-.06 1.738 1.535-.054.061a6.141 6.141 0 0 1-4.607 2.085C2.755 12.308 0 9.548 0 6.155 0 2.819 2.75 0 6.007 0zm.133 2.324a3.854 3.854 0 0 0-3.706 2.888h7.413A3.853 3.853 0 0 0 6.14 2.324z",
    id: "atr99iguio"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.077 0c6.118 0 11.077 4.96 11.077 11.077s-4.96 11.077-11.077 11.077C4.959 22.154 0 17.194 0 11.077 0 4.959 4.96 0 11.077 0z",
    id: "b5haq7j1iq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.024 0c1.74 0 3.053 1.183 3.053 2.753v3.4H9.943v-3.4c0-.954-.86-1.73-1.92-1.73-1.057 0-1.918.776-1.918 1.73v3.4H4.972v-3.4c0-.954-.861-1.73-1.919-1.73s-1.92.776-1.92 1.73v3.4H0v-3.4C0 1.183 1.313 0 3.053 0 4.045 0 5 .459 5.538 1.183 6.075.459 7.031 0 8.024 0z",
    id: "rhb13ho8rs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.014 0v3.706c0 1.055.787 1.914 1.755 1.914.968 0 1.755-.859 1.755-1.914V0h1.014v6.826c0 1.665-1.242 3.02-2.769 3.02-1.22 0-2.282-.853-2.644-2.122l-.068-.236.968-.329.067.236c.23.805.904 1.345 1.677 1.345.968 0 1.755-.858 1.755-1.914v-.854c-.487.47-1.14.755-1.755.755C1.243 6.727 0 5.372 0 3.707V0h1.014z",
    id: "w6zl8qjh8u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.313 0v12.9c0 1.634.7 2.428 2.139 2.428.072 0 .144-.002.217-.005l.254-.014v2.466l-.215.027a5.17 5.17 0 0 1-.668.044C1.548 17.846 0 15.98 0 12.973V0h2.313z",
    id: "52cdj0a6dw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.313 0v12.9c0 1.634.7 2.428 2.138 2.428.072 0 .145-.002.218-.005l.254-.014v2.466l-.215.027a5.17 5.17 0 0 1-.669.044C1.548 17.846 0 15.98 0 12.973V0h2.313z",
    id: "u0qgh6c1qy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.692 0a3.697 3.697 0 0 1 3.693 3.692 3.697 3.697 0 0 1-3.693 3.693A3.696 3.696 0 0 1 0 3.692 3.696 3.696 0 0 1 3.692 0zm0 2.171c-.838 0-1.52.683-1.52 1.522 0 .838.682 1.52 1.52 1.52.84 0 1.522-.682 1.522-1.52 0-.84-.682-1.522-1.521-1.522z",
    id: "njbdf95x5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.154 0a6.161 6.161 0 0 1 6.154 6.154 6.16 6.16 0 0 1-6.154 6.154A6.16 6.16 0 0 1 0 6.154 6.161 6.161 0 0 1 6.154 0zm0 2.322a3.836 3.836 0 0 0-3.832 3.832 3.836 3.836 0 0 0 3.832 3.832 3.836 3.836 0 0 0 3.832-3.832 3.836 3.836 0 0 0-3.832-3.832z",
    id: "y6pwke86nC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.154 11.077)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lyhlzef3rb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3easxwhcia"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#lyhlzef3rb)",
    d: "M0 12.308h20.308V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104 11.692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y5gdlxgbad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#17wt3gtyfc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#y5gdlxgbad)",
    d: "M0 12.308h12.308V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.846 11.692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mws8gxxnof",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#42l08u0kse"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#mws8gxxnof)",
    d: "M0 12.308h12.308V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.077 5.538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0ksya8jyjh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z5b5lfuxmg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#0ksya8jyjh)",
    d: "M0 17.846h11.692V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.538 11.692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lfcxdf0qaj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#usez8f0q8i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#lfcxdf0qaj)",
    d: "M0 12.308h12.308V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.23 9.846)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "40e1k6rjel",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0zepm04izk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#40e1k6rjel)",
    d: "M0 3.077h3.077V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.385 5.538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uetpbi31rn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6e3slel4wm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#uetpbi31rn)",
    d: "M0 17.846h12.308V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.692 11.692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "der1erphbp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#atr99iguio"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#der1erphbp)",
    d: "M0 12.308h12.308V0H0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "g8t1i89dkr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5haq7j1iq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#g8t1i89dkr)",
    d: "M0 22.154h22.154V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.462 7.385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p6wc8pnjet",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rhb13ho8rs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#p6wc8pnjet)",
    d: "M0 6.154h11.077V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.154 7.385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7dy0ezvcqv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w6zl8qjh8u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#7dy0ezvcqv)",
    d: "M0 9.846h5.538V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.923 5.538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "de05mdqipx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#52cdj0a6dw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#de05mdqipx)",
    d: "M0 17.846h4.923V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.308 5.538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2j2pnd6i7z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u0qgh6c1qy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#2j2pnd6i7z)",
    d: "M0 17.846h4.923V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.308 24.615)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nbs054bucB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#njbdf95x5A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#nbs054bucB)",
    d: "M0 7.385h7.385V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.385 11.692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l8ei3ksdiD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y6pwke86nC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1B",
    mask: "url(#l8ei3ksdiD)",
    d: "M0 12.308h12.308V0H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.29401b981b42b6433c6a4f4f177e7cd6.svg";
export { ForwardRef as ReactComponent };